<template>
    <section class="feedback" :class="{
        'feedback-auth': !userIsEmpty('user'),
        'feedback-unauth': userIsEmpty('user'),
    }">
        <h1 class="heading">
            <div class="container-mobile">
                {{ $t("feedback.feedback") }}
            </div>
        </h1>

        <div class="info-block container-mobile">
            <div v-if="userIsEmpty('user')" class="form-group">
                <label for="name" class="label"> {{ $t("feedback.name") }}:</label>
                <input type="text" v-model="name" name="name" ref="name" v-validate="'required'" id="name" class="input"
                    :class="{ 'field-error': errors.has('name') }" />
                <label class="v-error label-tip" v-if="errors.first('name')">
                    <!-- {{ errors.first("name") }} -->
                    {{ $t("login.required") }}
                </label>
            </div>
            <div v-if="userIsEmpty('user')" class="form-group">
                <label for="email_or_phone" class="label">
                    {{ $t("feedback.emailOrPhone") }}:
                </label>
                <input type="text" v-model="email_or_phone" name="email_or_phone" ref="email_or_phone"
                    v-validate="'required|phoneOrMail'" id="email_or_phone" class="input"
                    :class="{ 'field-error': errors.has('email_or_phone') }" />
                <label class="v-error label-tip" v-if="errors.first('email_or_phone')">
                    <!-- {{ errors.first("email_or_phone") }} -->
                    {{ $t("login.required") }}
                </label>
            </div>
            <div class="form-group">
                <label for="subject" class="label">
                    {{ $t("feedback.subjectLine") }}:
                </label>
                <input type="text" v-model="subject" name="subject" ref="subject" v-validate="'required'" id="subject"
                    class="input" :class="{ 'field-error': errors.has('subject') }" />
                <label class="v-error label-tip" v-if="errors.first('subject')">
                    <!-- {{ errors.first("subject") }} -->
                    {{ $t("login.required") }}
                </label>
            </div>
            <div class="form-group">
                <label for="text" class="label">{{ $t("feedback.message") }}:</label>
                <textarea v-model="text" name="text" ref="text" v-validate="'required'" id="text" class="textarea"
                    :class="{ 'field-error': errors.has('text') }"></textarea>
                <label class="v-error label-tip" v-if="errors.has('text')">
                    <!-- {{ errors.first("text") }} -->
                    {{ $t("login.required") }}
                </label>
            </div>
            <div class="buttons-row">
                <button v-if="!loader" @click="send" class="button">
                    {{ $t("feedback.send") }}
                </button>
                <button v-if="loader" type="button" class="button button-loader"></button>
            </div>
        </div>
    </section>
</template>

<script>
import { mapGetters } from "vuex";
import { localizeValidation } from "@/mixins/localizeValidation";

export default {
    name: "Feedback",
    props: {
        i18n: Object,
    },
    mixins: [localizeValidation],
    data() {
        return {
            loader: false,
            name: "",
            email_or_phone: "",
            subject: "",
            text: "",
            tempEmailOrPhone: "",
        };
    },
    computed: {
        ...mapGetters({
            userIsEmpty: "user/isEmpty",
            user: "user/fetchUser",
            userErrors: "user/errors",
            feedbackErrors: "feedback/errors",
        }),
    },
    created() {
        this.localizeValidation();

        let self = this;

        const phoneOrMailRule = {
            getMessage(field, isPhoneOrMail, data) {
                return (data && data.message) || $t("feedback.enterCorrectAddress");
            },
            validate(value, isPhoneOrMail) {
                if (isPhoneOrMail) {
                    if (self.email_or_phone.indexOf("@") >= 0) {
                        const regexMail =
                            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        return {
                            data: { message: $t("feedback.enterValidEmailAddress") },
                            valid: regexMail.test(self.email_or_phone),
                        };
                    } else if (
                        /^\+/.test(self.email_or_phone) ||
                        /[0-9]{2,}/.test(self.email_or_phone)
                    ) {
                        self.tempEmailOrPhone = self.email_or_phone.replace(
                            /[^+0-9.]/g,
                            ""
                        );
                        const regexPhone = /^\+[0-9]{11,}$/;
                        return {
                            data: {
                                message: $t("feedback.phoneFormat"),
                            },
                            valid: regexPhone.test(self.tempEmailOrPhone),
                        };
                    }
                    return { data: null, valid: false };
                } else {
                    return { valid: true };
                }
            },
        };

        this.$validator.extend("phoneOrMail", phoneOrMailRule);
    },
    methods: {
        send() {
            if (this.loader) {
                return;
            }
            this.$validator.validateAll().then((valid) => {
                if (valid) {
                    this.loader = true;
                    let data = {
                        subject: this.subject,
                        text: this.text,
                    };
                    if (this.userIsEmpty("user")) {
                        (data.name = this.name),
                            (data.email_or_phone =
                                this.tempEmailOrPhone || this.email_or_phone);
                    }
                    this.$store
                        .dispatch("feedback/send", data)
                        .then(() => {
                            this.loader = false;
                            this.$modal.show("dialog", {
                                title: $t("myFriends.success"),
                                text: $t("feedback.yourSuccessfullySent"),
                                buttons: [
                                    {
                                        title: $t("roulette.ok"),
                                    },
                                ],
                            });
                            this.name = "";
                            this.email_or_phone = "";
                            this.tempEmailOrPhone = "";
                            this.subject = "";
                            this.text = "";
                            this.errors.clear();
                            this.$validator.reset();
                        })
                        .catch(() => {
                            this.loader = false;
                            if (typeof this.feedbackErrors === "object") {
                                for (let key in this.feedbackErrors) {
                                    this.errors.add({
                                        field: key,
                                        msg: this.feedbackErrors[key][0],
                                    });
                                }
                            }
                        });
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/components/_validation";
@import "~@/assets/styles/pages/_feedback";
</style>
